import { SEO } from "../components/SEO";
import { PageHero } from "../components/PageHero";
import { Section, SectionHeader } from "../components/Section";
import { CTASection } from "../components/CTASection";
import { DOWNLOADS } from "../lib/content";
import { useTranslation } from "../lib/i18n";

export default function DownloadsPage() {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title="Downloads — Sentinel"
        description="Download Sentinel PDFs and PPTX: Architecture Overview, Domain Templates, Intervention Libraries, OEM Integration Guide, Safety Analytics, Certification Requirements, Training Catalog, and Pitch Deck."
        canonical="/downloads"
        image="https://images.pexels.com/photos/8111872/pexels-photo-8111872.jpeg?auto=compress&cs=tinysrgb&w=1200"
      />
      <PageHero
        eyebrow={t("downloads.page.eyebrow")}
        title={t("downloads.page.title")}
        description={t("downloads.page.description")}
        bgVariant="steel"
        bgImage="https://images.pexels.com/photos/8111872/pexels-photo-8111872.jpeg?auto=compress&cs=tinysrgb&w=1600"
      />

      <Section>
        <SectionHeader
          eyebrow={t("downloads.library.eyebrow")}
          title={t("downloads.library.title")}
        />
        <div className="grid grid-3">
          {DOWNLOADS.map((dl) => (
            <div
              key={dl.id}
              className="card card-hover"
              style={{ display: "flex", flexDirection: "column" }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "1rem" }}>
                <div
                  style={{
                    width: "44px",
                    height: "44px",
                    borderRadius: "var(--radius-md)",
                    background: dl.format === "PDF" ? "var(--error-50)" : "var(--warning-50)",
                    color: dl.format === "PDF" ? "var(--error-600)" : "var(--warning-700)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 800,
                    fontSize: "0.75rem",
                  }}
                >
                  {dl.format}
                </div>
                <span className="badge" style={{ background: "var(--neutral-100)", color: "var(--neutral-600)" }}>
                  {dl.category}
                </span>
              </div>
              <h3 style={{ fontSize: "1.0625rem", marginBottom: "0.5rem" }}>{dl.title}</h3>
              <p className="text-muted" style={{ fontSize: "0.9375rem", marginBottom: "1rem", flex: 1 }}>
                {dl.description}
              </p>
              <button className="btn btn-secondary btn-block" style={{ marginTop: "auto" }}>
                {t("common.download")} {dl.format}
              </button>
            </div>
          ))}
        </div>
      </Section>

      <CTASection
        title={t("downloads.cta.title")}
        description={t("downloads.cta.description")}
        primaryLabel={t("cta.contactUs")}
        primaryTo="/contact"
        secondaryLabel={t("cta.viewArchitecture")}
        secondaryTo="/architecture"
      />
    </>
  );
}
